<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Settings</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div class="d-flex">
      <div
        ngbNav
        #nav="ngbNav"
        [(activeId)]="active"
        class="nav-pills"
        orientation="vertical"
      >
        <ng-container ngbNavItem="recipients">
          <button ngbNavLink>Recipients</button>
          <ng-template ngbNavContent>
            <app-recipient></app-recipient>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem="audit-logs">
          <button ngbNavLink>Audit logs</button>
          <ng-template ngbNavContent>
            <!-- Insert component here -->
            <app-audit-log-table></app-audit-log-table>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem="change-this-id-later-on">
          <button ngbNavLink>Get legacy template</button>
          <ng-template ngbNavContent>
            <!-- Insert component here -->
            <app-import-legacy-template
              [onClose]="closeFromChild.bind(this, modal)">
            </app-import-legacy-template>
          </ng-template>
        </ng-container>
      </div>

      <div [ngbNavOutlet]="nav" class="ms-4 w-100"></div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="modal.close('Close click')"
    >
      Close
    </button>
  </div>
</ng-template>
